import Button from "./Button";
import Dialog from "./Dialog";

export default function ConfirmDialog({
  open,
  onClose,
  onCancel,
  onConfirm,
  title = "",
  size = "sm",
  eyebrow,
  description,
  message,
  confirmLabel = "확인",
  cancelLabel = "취소",
  tone = "danger",
  busy = false,
  error = "",
  confirmDisabled = false,
  cancelDisabled = false,
  dismissible = true,
  children,
}) {
  const handleClose = onCancel || onClose;
  const handleConfirm = onConfirm || handleClose;
  const resolvedDescription = description ?? message;
  const confirmVariant = tone === "danger" ? "danger" : "primary";

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      size={size}
      title={title || "안내"}
      eyebrow={eyebrow}
      busy={busy}
      dismissible={dismissible}
      className={`ds-confirm-dialog ds-confirm-dialog--${tone}`}
      bodyClassName="ds-confirm-dialog__body"
      footer={(
        <>
          {cancelLabel ? (
            <Button
              variant="secondary"
              size="large"
              type="button"
              onClick={handleClose}
              disabled={busy || cancelDisabled}
            >
              {cancelLabel}
            </Button>
          ) : null}
          <Button
            variant={confirmVariant}
            size="large"
            type="button"
            onClick={handleConfirm}
            loading={busy}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </Button>
        </>
      )}
    >
      <div className="ds-confirm-dialog__content">
        {resolvedDescription ? (
          <p className="ds-confirm-dialog__message">{resolvedDescription}</p>
        ) : null}
        {children}
        {error && <div className="ds-confirm-dialog__error" role="alert">{error}</div>}
      </div>
    </Dialog>
  );
}
